// Catalogue FR — source de référence (la plus complète).
// Convention : keys plates en notation pointée (domain.subdomain.key).
// Interpolation : utiliser {param} dans la chaîne, remplacé par t('key', { param: value }).

const fr = {
    // ─── Communs ─────────────────────────────────────────────────────────
    'common.app_name': 'CAP Assurances',
    'common.tagline': 'Société de Courtage',
    'common.loading': 'Chargement...',
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.confirm': 'Confirmer',
    'common.delete': 'Supprimer',
    'common.edit': 'Modifier',
    'common.add': 'Ajouter',
    'common.view': 'Voir',
    'common.detail': 'Détail',
    'common.search': 'Rechercher',
    'common.export': 'Exporter',
    'common.print': 'Imprimer',
    'common.back': 'Retour',
    'common.next': 'Suivant',
    'common.previous': 'Précédent',
    'common.required': 'Obligatoire',
    'common.optional': 'Optionnel',
    'common.yes': 'Oui',
    'common.no': 'Non',
    'common.all': 'Tous',
    'common.none': 'Aucun',
    'common.total': 'Total',
    'common.actions': 'Actions',
    'common.status': 'Statut',
    'common.date': 'Date',
    'common.amount': 'Montant',
    'common.created_at': 'Date de création',
    'common.updated_at': 'Dernière modification',

    // ─── Authentification ────────────────────────────────────────────────
    'auth.login.title': 'Connexion',
    'auth.login.subtitle': 'Espace courtier sécurisé',
    'auth.login.phone': 'Téléphone',
    'auth.login.password': 'Mot de passe',
    'auth.login.submit': 'Se connecter',
    'auth.login.loading': 'Connexion...',
    'auth.login.broker_tagline': 'Votre courtier en assurances de confiance',
    'auth.logout.success': 'Déconnexion réussie',
    'auth.session.expired': 'Votre session a expiré. Veuillez vous reconnecter.',
    'auth.session.idle_warning': 'Vous serez automatiquement déconnecté dans {seconds} secondes par inactivité.',
    'auth.session.stay_connected': 'Rester connecté',

    // ─── Navigation principale ───────────────────────────────────────────
    'nav.dashboard': 'Tableau de bord',
    'nav.gestion': 'Gestion',
    'nav.clients': 'Clients',
    'nav.clients_list': 'Liste clients',
    'nav.clients_add': 'Nouveau client',
    'nav.contrats': 'Contrats',
    'nav.contrats_list': 'Liste contrats',
    'nav.contrats_add': 'Nouveau contrat',
    'nav.contrats_echeances': 'Échéances du mois',
    'nav.echeances': 'Échéances',
    'nav.reglements': 'Règlements',
    'nav.impayes': 'Impayés',
    'nav.sinistres': 'Sinistres',
    'nav.rapports': 'Rapports',
    'nav.bilans': 'Bilans & États',
    'nav.audit': "Journal d'activité",
    'nav.admin': 'Administration',
    'nav.users': 'Administrateurs',
    'nav.roles': 'Rôles',
    'nav.profile': 'Mon profil',
    'nav.config': 'Configuration',
    'nav.compagnies': 'Compagnies',
    'nav.types_assurance': "Types d'assurance",
    'nav.agences': 'Agences',
    'nav.parametrages': 'Paramètres',

    // ─── Mégamenus : labels & descriptions courtes ────────────────────────
    'nav.megamenu.section.gestion': 'GESTION',
    'nav.megamenu.section.bilans': 'BILANS & ÉTATS',
    'nav.megamenu.section.referentiels': 'RÉFÉRENTIELS',
    'nav.megamenu.section.administration': 'ADMINISTRATION',
    'nav.megamenu.section.actions': 'ACTIONS RAPIDES',

    'nav.megamenu.desc.clients': 'Particuliers & entreprises',
    'nav.megamenu.desc.contrats': 'Polices & renouvellements',
    'nav.megamenu.desc.echeances': 'Contrats à renouveler',
    'nav.megamenu.desc.reglements': 'Encaissements & échéances',
    'nav.megamenu.desc.impayes': 'Suivi & relances SMS',
    'nav.megamenu.desc.sinistres': 'Déclaration & workflow',
    'nav.megamenu.desc.etat_reglements': 'Synthèse par contrat / client',
    'nav.megamenu.desc.bilans': "Vue d'ensemble",
    'nav.megamenu.desc.bordereau': 'Versements compagnies',
    'nav.megamenu.desc.etat_clients': 'Engagement / règlement',
    'nav.megamenu.desc.compagnies': 'Assureurs partenaires',
    'nav.megamenu.desc.types_assurance': 'Produits proposés',
    'nav.megamenu.desc.agences': 'Sites & coordonnées',
    'nav.megamenu.desc.marques_vehicule': 'Constructeurs auto',
    'nav.megamenu.desc.referentiels_vehicule': 'Modèles & variantes',
    'nav.megamenu.desc.parametrages': 'Réglages généraux',
    'nav.megamenu.desc.users': 'Staff & courtiers',
    'nav.megamenu.desc.roles': 'Permissions RBAC',
    'nav.megamenu.desc.audit': "Journal d'activité",

    'nav.megamenu.label.etat_reglements': 'État règlements',
    'nav.megamenu.label.bordereau': 'Bordereau courtier',
    'nav.megamenu.label.etat_clients': 'État clients',
    'nav.megamenu.label.marques_vehicule': 'Marques véhicule',
    'nav.megamenu.label.referentiels_vehicule': 'Référentiels véhicule',
    'nav.megamenu.label.new_admin': 'Nouvel administrateur',

    // ─── Notifications ───────────────────────────────────────────────────
    'notif.center.title': 'Centre de notifications',
    'notif.center.empty': 'Aucune alerte en cours',
    'notif.center.empty_sub': 'Vous êtes à jour 🎉',
    'notif.center.up_to_date': 'Tout est à jour',
    'notif.center.pending': 'Actions en attente',
    'notif.center.mark_read': 'Marquer comme lues',
    'notif.echeances': 'Échéances ce mois',
    'notif.impayes': 'Impayés',
    'notif.sinistres': 'Sinistres à instruire',

    // ─── Métier : clients ────────────────────────────────────────────────
    'clients.title': 'Gestion Clients',
    'clients.subtitle': 'Clients et prospects',
    'clients.add.title': 'Nouveau client',
    'clients.type.particulier': 'Particulier',
    'clients.type.entreprise': 'Entreprise',
    'clients.field.nom': 'Nom',
    'clients.field.prenom': 'Prénom(s)',
    'clients.field.raison_sociale': 'Raison sociale',
    'clients.field.telephone': 'Téléphone',
    'clients.field.email': 'Email',
    'clients.field.adresse': 'Adresse',
    'clients.field.agence': 'Agence',
    'clients.empty': 'Aucun client trouvé',
    'clients.delete.confirm': 'Supprimer ce client ?',
    'clients.delete.success': 'Client supprimé avec succès',

    // ─── Métier : contrats ───────────────────────────────────────────────
    'contrats.title': 'Gestion Contrats',
    'contrats.add.title': 'Nouveau contrat',
    'contrats.renew.title': 'Renouvellement de contrat',
    'contrats.edit.title': 'Modifier le contrat',
    'contrats.field.numero_police': 'N° Police',
    'contrats.field.compagnie': 'Compagnie',
    'contrats.field.type_assurance': "Type d'assurance",
    'contrats.field.prime_ttc': 'Prime TTC',
    'contrats.field.date_effet': "Date d'effet",
    'contrats.field.date_echeance': "Date d'échéance",
    'contrats.field.duree': 'Durée (mois)',
    'contrats.empty': 'Aucun contrat trouvé',
    'contrats.statut.actif': 'Actif',
    'contrats.statut.expire': 'Expiré',
    'contrats.statut.suspendu': 'Suspendu',
    'contrats.statut.resilie': 'Résilié',
    'contrats.statut.renouvele': 'Renouvelé',

    // ─── Métier : règlements ─────────────────────────────────────────────
    'reglements.title': 'Règlements',
    'reglements.encaisser': 'Encaisser',
    'reglements.encaisser.short': 'Encaisser ({amount} F)',
    'reglements.solde_complet': 'Solde complet',
    'reglements.field.montant': 'Montant',
    'reglements.field.moyen': 'Mode de paiement',
    'reglements.field.reference': 'Référence',
    'reglements.field.banque': 'Banque',
    'reglements.field.observation': 'Observation',
    'reglements.moyen.especes': 'Espèces',
    'reglements.moyen.cheque': 'Chèque',
    'reglements.moyen.virement': 'Virement',
    'reglements.moyen.mobile_money': 'Mobile Money',

    // ─── Métier : sinistres ──────────────────────────────────────────────
    'sinistres.title': 'Sinistres',
    'sinistres.declare': 'Déclarer un sinistre',
    'sinistres.field.date_sinistre': 'Date du sinistre',
    'sinistres.field.type': 'Type',
    'sinistres.field.description': 'Description',
    'sinistres.statut.declare': 'Déclaré',
    'sinistres.statut.en_cours': "En cours d'instruction",
    'sinistres.statut.regle': 'Réglé',
    'sinistres.statut.rejete': 'Rejeté',

    // ─── Thème & préférences ─────────────────────────────────────────────
    'pref.theme.title': 'Apparence',
    'pref.theme.description': "Choisissez le thème de l'interface (préférence sauvegardée pour ce navigateur).",
    'pref.theme.light': 'Clair',
    'pref.theme.dark': 'Sombre',
    'pref.theme.system': 'Auto (système)',
    'pref.lang.title': 'Langue',
    'pref.lang.description': "Choisissez la langue de l'interface.",
    'pref.lang.fr': 'Français',
    'pref.lang.en': 'English',

    // ─── Erreurs & validation ────────────────────────────────────────────
    'error.required': 'Le {field} est obligatoire',
    'error.phone_format': 'Le numéro doit contenir 10 chiffres (sans indicatif)',
    'error.email_format': "Format d'email invalide (ex : nom@domaine.ci)",
    'error.api': 'Erreur lors du chargement des données',

    // ─── Dashboard ───────────────────────────────────────────────────────
    'dashboard.greeting.morning': 'Bonjour',
    'dashboard.greeting.afternoon': 'Bon après-midi',
    'dashboard.greeting.evening': 'Bonsoir',
    'dashboard.refresh': 'Actualiser',
    'dashboard.period.week': 'Cette semaine',
    'dashboard.period.month': 'Ce mois',
    'dashboard.period.quarter': 'Ce trimestre',
    'dashboard.period.year': 'Cette année',
    'dashboard.agence.all': 'Toutes les agences',

    'dashboard.quick.title': 'Actions rapides',
    'dashboard.quick.new_client': 'Nouveau client',
    'dashboard.quick.new_contrat': 'Nouveau contrat',
    'dashboard.quick.cash_in': 'Encaisser',
    'dashboard.quick.declare_claim': 'Déclarer sinistre',

    'dashboard.kpi.production': 'Ma production',
    'dashboard.kpi.production.sub': '{count} contrats actifs',
    'dashboard.kpi.ca': 'Mon CA',
    'dashboard.kpi.ca.sub': 'Ce mois',
    'dashboard.kpi.clients': 'Mes clients',
    'dashboard.kpi.clients.sub': '{count} actifs',
    'dashboard.kpi.vs_prev': 'vs {month}',
    'dashboard.kpi.no_compare': 'Pas de référence précédente',

    'dashboard.todo.title': "À faire aujourd'hui",
    'dashboard.todo.empty': '🎉 Rien d\'urgent — bonne journée !',
    'dashboard.todo.empty_sub': 'Vous êtes à jour sur les actions prioritaires.',
    'dashboard.todo.impayes': '{count} impayés à recouvrer',
    'dashboard.todo.impayes.action': 'Relancer',
    'dashboard.todo.echeances_proches': '{count} contrats à renouveler dans 7 jours',
    'dashboard.todo.echeances_proches.action': 'Voir',
    'dashboard.todo.sinistres': '{count} sinistres en attente d\'instruction',
    'dashboard.todo.sinistres.action': 'Détail',

    'dashboard.echeances.title': 'Prochaines échéances',
    'dashboard.echeances.tab_7': '7 jours',
    'dashboard.echeances.tab_15': '15 jours',
    'dashboard.echeances.tab_30': '30 jours',
    'dashboard.echeances.empty': '✅ Aucune échéance — bon moment pour prospecter',
    'dashboard.echeances.empty_window': 'Aucune échéance dans cette fenêtre — {count} contrat(s) à venir plus tard',
    'dashboard.echeances.next_on': 'Prochaine échéance le {date}',
    'dashboard.echeances.in_days': 'Dans {n}j',
    'dashboard.echeances.tomorrow': 'Demain',
    'dashboard.echeances.today': "Aujourd'hui",
    'dashboard.echeances.overdue': 'En retard',

    'dashboard.chart.title': 'Mon CA — 6 derniers mois',
    'dashboard.chart.tooltip_contracts': '{n} contrats',
    'dashboard.chart.empty': 'Aucune donnée sur la période',

    'dashboard.error.load': 'Impossible de charger une partie du tableau de bord. Cliquez sur Actualiser pour réessayer.',

    // ─── Navbar & Layout ─────────────────────────────────────────────────
    'nav.open_menu': 'Ouvrir le menu',
    'nav.close_menu': 'Fermer le menu',
    'nav.create': 'Créer',
    'nav.create_client': 'Nouveau client',
    'nav.create_contrat': 'Nouveau contrat',
    'nav.create_reglement': 'Encaisser un règlement',
    'nav.create_sinistre': 'Déclarer un sinistre',
    'nav.agence.all': 'Toutes les agences',
    'nav.agence.label': 'Agence active',
    'nav.help': 'Aide & raccourcis',
    'nav.help_full': 'Centre d\'aide',
    'nav.logout': 'Se déconnecter',
    'nav.my_profile': 'Mon profil',
    'nav.user.role_label': 'Rôle',
    'nav.user.agence_label': 'Agence',
    'nav.theme.light_short': 'Clair',
    'nav.theme.dark_short': 'Sombre',
    'nav.theme.system_short': 'Auto',
    'nav.theme.title': 'Thème : {mode} (cliquer pour changer)',
    'nav.locale.title': 'Langue : {locale} (cliquer pour {next})',

    // ─── Breadcrumb ──────────────────────────────────────────────────────
    'breadcrumb.home': 'Accueil',

    // ─── Footer ──────────────────────────────────────────────────────────
    'footer.copyright': '© {year} Cap Assurances — Société de Courtage',
    'footer.made_with': 'Fait avec',
    'footer.in_ci': "en Côte d'Ivoire",
    'footer.legal': 'Mentions légales',
    'footer.privacy': 'Confidentialité',
    'footer.support': 'Support',
    'footer.version': 'Backoffice v{version}',

    // ─── Mot de passe forcé ──────────────────────────────────────────────
    'force_password.title': 'Changement de mot de passe obligatoire',
    'force_password.intro': 'Pour des raisons de sécurité, vous devez changer votre mot de passe par défaut avant de continuer.',
    'force_password.current': 'Mot de passe actuel',
    'force_password.new': 'Nouveau mot de passe',
    'force_password.confirm': 'Confirmer le nouveau mot de passe',
    'force_password.submit': 'Changer le mot de passe',
    'force_password.submitting': 'Modification en cours...',
    'force_password.min': 'Au moins 6 caractères',
    'force_password.mismatch': 'Les mots de passe ne correspondent pas',
    'force_password.success': 'Mot de passe modifié avec succès',
    'force_password.error': 'Erreur lors du changement de mot de passe',

    // ─── Accessibilité ───────────────────────────────────────────────────
    'a11y.skip_to_content': 'Aller au contenu principal',
    'a11y.session_warning_title': 'Session bientôt expirée',
};

export default fr;
